import React, { useState, useEffect } from 'react';
import Icon from './Icon';
import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { io } from 'socket.io-client';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import ChatWidget from './ChatWidget';
import API, { getBranch, setBranch } from '../services/api';
import { fmtShortTime } from '../utils/date';
import { MENYU_HADISE, MENYU_ACARLAR, ayarOxu } from '../utils/menyuAyarlari';
import { APP_VERSION } from '../version';
import BranchSwitcher from './BranchSwitcher';
import './Layout.css';

let _notifSocket = null;
function getNotifSocket(token) {
  if (!_notifSocket || !_notifSocket.connected) {
    _notifSocket = io(window.location.origin, {
      auth: { token },
      transports: ['websocket', 'polling'],
    });
  }
  return _notifSocket;
}
function playNotifBeep() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.frequency.value = 880;
    gain.gain.value = 0.08;
    osc.start(); osc.stop(ctx.currentTime + 0.15);
  } catch (e) {}
}

const Icons = {
  dashboard: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
      <rect x="14" y="14" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/>
    </svg>
  ),
  students: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3L2 8l10 5 10-5-10-5z"/><path d="M2 8v6"/><path d="M6 10.5v5a6 3 0 0012 0v-5"/>
    </svg>
  ),
  teachers: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="7" r="4"/><path d="M2 21v-2a7 7 0 0114 0v2"/><path d="M19 8v6m-3-3h6"/>
    </svg>
  ),
  classes: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21h18M3 7v14M21 7v14M6 11h4m-4 4h4m4-4h4m-4 4h4M6 3h12a1 1 0 011 1v3H5V4a1 1 0 011-1z"/>
    </svg>
  ),
  subjects: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/>
    </svg>
  ),
  attendance: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
      <rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 12l2 2 4-4"/>
    </svg>
  ),
  grades: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 20V10M12 20V4M6 20v-6"/>
    </svg>
  ),
  schedule: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/>
    </svg>
  ),
  announcements: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/>
    </svg>
  ),
  requests: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
      <polyline points="14,2 14,8 20,8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/>
    </svg>
  ),
  leave: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/>
      <rect x="9" y="3" width="6" height="4" rx="1" ry="1"/>
      <path d="M9 12h6M9 16h4"/>
    </svg>
  ),
  users: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/>
    </svg>
  ),
  warehouse: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21V8l9-5 9 5v13"/><path d="M7 21v-7h10v7"/><path d="M7 17h10"/>
    </svg>
  ),
  building: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 21h18"/><path d="M5 21V6l8-3v18"/><path d="M19 21V10l-6-3"/>
      <path d="M9 9h.01M9 12h.01M9 15h.01M9 18h.01"/>
    </svg>
  ),
};

const menuItems = [
  { path: '/', icon: 'dashboard', label: 'İdarə paneli', exact: true, group: 'main' },
  { path: '/requests', icon: 'requests', label: 'Şöbələr', group: 'main' },
  { path: '/warehouse', icon: 'warehouse', label: 'Anbar', group: 'main', deptGated: 'warehouse' },
  { path: '/students', icon: 'students', label: 'Tələbələr', group: 'academic' },
  { path: '/teachers', icon: 'teachers', label: 'Müəllimlər', group: 'academic' },
  { path: '/classes', icon: 'classes', label: 'Siniflər', group: 'academic' },
  { path: '/subjects', icon: 'subjects', label: 'Fənlər', group: 'academic' },
  { path: '/attendance', icon: 'attendance', label: 'Davamiyyət', group: 'academic' },
  { path: '/grades', icon: 'grades', label: 'Qiymətlər', group: 'academic' },
  { path: '/timetable-builder', icon: 'schedule', label: 'Cədvəl Tərtibçisi', group: 'academic' },
  // Qəbul şöbəsi akademik bölmədən ayrıdır — öz başlığı altında durur
  { path: '/enrollment', icon: 'attendance', label: 'Şagird qeydiyyatı', group: 'admission' },
  { path: '/analytics', icon: 'grades', label: 'Analitika', group: 'system' },
  { path: '/announcements', icon: 'announcements', label: 'Elanlar', group: 'comm' },
  { path: '/users', icon: 'users', label: 'İstifadəçilər', adminOnly: true, group: 'system' },
  /* Menyunun görünüşü hər kəsin öz seçimidir — icazə tələb etmir,
     ona görə `herkese` nişanı ilə icazə süzgəcindən kənarda qalır. */
  { path: '/menu-setup', icon: 'settings', label: 'Menyu quraşdırması', group: 'system', herkese: true },
];

const GROUP_KEYS = {
  main: 'sidebar.groupMain',
  academic: 'sidebar.groupAcademic',
  admission: 'sidebar.groupAdmission',
  comm: 'sidebar.groupComm',
  system: 'sidebar.groupSystem',
};
const GROUP_ORDER = ['main', 'academic', 'admission', 'comm', 'system'];

const SIDEBAR_KEYS = {
  '/': 'dashboard', '/students': 'students', '/teachers': 'teachers',
  '/classes': 'classes', '/subjects': 'subjects', '/attendance': 'attendance',
  '/grades': 'grades', '/timetable-builder': 'timetableBuilder',
  '/announcements': 'announcements', '/requests': 'requests',
  '/enrollment': 'enrollment', '/users': 'users',
  '/analytics': 'analytics', '/warehouse': 'warehouse',
  '/menu-setup': 'menuSetup',
};

/* Yan panelin rəng çaları. `reng` qradiyentin ən açıq pilləsi, `vurgu`
   isə aktiv bəndin rəngidir — ikisi birlikdə seçim dairəsini düzəldir.
   Həqiqi dəyərlər Layout.css-dəki [data-yan-tema] bloklarındadır;
   burada yalnız nümunə dairəsi üçün lazımdır. */
const TEMALAR = [
  { ad: 'firuzeyi',  reng: '#0f3a3f', vurgu: '#5eead4' },
  { ad: 'gece',      reng: '#1c2750', vurgu: '#93c5fd' },
  { ad: 'sherab',    reng: '#411a33', vurgu: '#fcd34d' },
  { ad: 'mese',      reng: '#174227', vurgu: '#86efac' },
  { ad: 'komur',     reng: '#2d3137', vurgu: '#fbbf24' },
  { ad: 'benovseyi', reng: '#322563', vurgu: '#c4b5fd' },
  { ad: 'buz',       reng: '#cfeaf3', vurgu: '#0e7490' },
  { ad: 'sedef',     reng: '#f2e7e2', vurgu: '#b45309' },
];

/* Yan panelin fon naxışı. Rəng çalarından asılı deyil — hər ikisi
   birlikdə seçilir. Nümunə düyməsinin şəkli CSS-dədir. */
const NAXISLAR = [
  { ad: 'yox',   acar: 'patternNone' },
  { ad: 'tor',   acar: 'patternGrid' },
  { ad: 'noqte', acar: 'patternDots' },
];

export default function Layout() {
  const { user, logout } = useAuth();
  const { lang, switchLang, t } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  /* Üst paneldə cari səhifənin adı. Ən uzun uyğun yol götürülür ki,
     /requests/12 kimi alt ünvanlar da öz bölməsini göstərsin. */
  const sehifeAdi = React.useMemo(() => {
    const yol = location.pathname;
    const uygun = menuItems
      .filter(m => m.path !== '/' && (yol === m.path || yol.startsWith(m.path + '/')))
      .sort((a, b) => b.path.length - a.path.length)[0];
    if (uygun) return t(SIDEBAR_KEYS[uygun.path] ? 'sidebar.' + SIDEBAR_KEYS[uygun.path] : '', uygun.label);
    if (yol === '/') return t('sidebar.dashboard');
    if (yol.startsWith('/chat')) return t('topbar.messages');
    if (yol.startsWith('/leave')) return t('leave.title');
    if (yol.startsWith('/procurement')) return t('sidebar.procurement', 'Təchizat');
    if (yol.startsWith('/profile')) return t('topbar.profile', 'Profil');
    if (yol.startsWith('/about')) return t('about.title', 'Sistem haqqında');
    return t('topbar.title');
  }, [location.pathname, t]);

  /* Dar ekranda uzun səhifə adı sığmır. Kəsmək əvəzinə onu axan sətirə
     çeviririk — mətn sona qədər sürüşür, sonra geri qayıdır. Yalnız
     həqiqətən sığmayanda işə düşsün deyə eni ölçülür; sürüşmə məsafəsi
     CSS-ə dəyişən kimi ötürülür. */
  const basliqRef = React.useRef(null);
  const basliqMtnRef = React.useRef(null);
  const [basliqAxsin, setBasliqAxsin] = React.useState(false);

  React.useEffect(() => {
    const el = basliqRef.current;
    const mtn = basliqMtnRef.current;
    if (!el || !mtn) return;

    /* Görünən en: sahənin öz eni ilə onu kəsən qabın eninin kiçiyi.
       Sahə "nowrap" olduğu üçün bəzi hallarda özü mətn qədər genişlənir
       və qabın altında kəsilir — onda scrollWidth ilə clientWidth bərabər
       olur və heç nə hərəkət etmirdi. Qabın enini də hesaba almaq bunu
       aradan qaldırır. */
    const olc = () => {
      const qab = el.parentElement;
      const gorunen = Math.min(
        el.clientWidth || Number.MAX_SAFE_INTEGER,
        qab ? qab.clientWidth : Number.MAX_SAFE_INTEGER
      );
      const lazim = mtn.scrollWidth;
      const artiq = lazim - gorunen;
      setBasliqAxsin(artiq > 4);
      el.style.setProperty('--axim', Math.max(0, artiq) + 'px');
      /* Uzun ad daha çox vaxt aparsın — sürət sabit qalsın */
      el.style.setProperty('--axim-muddet', Math.min(18, 5 + artiq / 22) + 's');
    };

    olc();
    /* Şriftlər sonra yüklənir — o vaxta qədər ölçü yanlış çıxır */
    const t1 = setTimeout(olc, 120);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(olc).catch(() => {});

    let ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(olc);
      ro.observe(el);
      if (el.parentElement) ro.observe(el.parentElement);
    }
    window.addEventListener('resize', olc);
    window.addEventListener('orientationchange', olc);
    return () => {
      clearTimeout(t1);
      if (ro) ro.disconnect();
      window.removeEventListener('resize', olc);
      window.removeEventListener('orientationchange', olc);
    };
  }, [sehifeAdi]);

  const toggleChat = () => {
    if (location.pathname === '/chat') {
      // Already on chat → close: go back if there's history, else home
      if (window.history.length > 1) navigate(-1);
      else navigate('/');
    } else {
      navigate('/chat');
    }
  };
  const [sidebarOpen, setSidebarOpen] = useState(true);
  /* Üst panel yığıla bilər — noutbuklarda cədvəl üçün 60px yer qazandırır.
     Seçim brauzerdə saxlanılır ki, hər girişdə yenidən bağlamaq lazım olmasın. */
  const [topbarHidden, setTopbarHidden] = useState(() => {
    try { return localStorage.getItem('ems_topbar_hidden') === '1'; } catch { return false; }
  });
  const toggleTopbar = () => setTopbarHidden(v => {
    const next = !v;
    try { localStorage.setItem('ems_topbar_hidden', next ? '1' : '0'); } catch {}
    return next;
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  /* Menyunun görünüş ayarları artıq "Menyu quraşdırması" səhifəsindədir.
     Burada yalnız oxunur: səhifə ayarı dəyişəndə hadisə göndərir, yan
     panel də dərhal yenilənir. */
  const [yanTema, setYanTema] = useState(() => {
    const x = ayarOxu(MENYU_ACARLAR.tema, 'firuzeyi');
    return TEMALAR.some(v => v.ad === x) ? x : 'firuzeyi';
  });
  const [yanNaxis, setYanNaxis] = useState(() => {
    const x = ayarOxu(MENYU_ACARLAR.naxis, 'yox');
    return NAXISLAR.some(v => v.ad === x) ? x : 'yox';
  });
  const [menyuGorunus, setMenyuGorunus] = useState(
    () => (ayarOxu(MENYU_ACARLAR.gorunus, 'siyahi') === 'setka' ? 'setka' : 'siyahi'));

  useEffect(() => {
    const dinle = (e) => {
      const { acar, deyer } = e.detail || {};
      if (acar === MENYU_ACARLAR.tema) setYanTema(deyer);
      if (acar === MENYU_ACARLAR.naxis) setYanNaxis(deyer);
      if (acar === MENYU_ACARLAR.gorunus) setMenyuGorunus(deyer);
    };
    window.addEventListener(MENYU_HADISE, dinle);
    return () => window.removeEventListener(MENYU_HADISE, dinle);
  }, []);
  const [langOpen, setLangOpen] = useState(false);
  const [notifs, setNotifs] = useState({ leave: 0, admission: 0, requests: 0, enrollment: 0 });
  const [notifItems, setNotifItems] = useState([]);
  const [notifUnread, setNotifUnread] = useState(0);
  const [myTickets, setMyTickets] = useState([]);
  const [myProc, setMyProc] = useState([]);
  const [showNotif, setShowNotif] = useState(false);
  const [chatUnread, setChatUnread] = useState(0);

  const [menuPerms, setMenuPerms] = useState(user?.menu_permissions || null);
  // Anbar bölməsi yalnız Anbar şöbəsinin üzvlərinə (və adminə) görünür
  const [whAccess, setWhAccess] = useState(false);
  useEffect(() => {
    API.get('/warehouse/access')
      .then(r => setWhAccess(!!r.data?.allowed))
      .catch(() => setWhAccess(false));
  }, []);
  const [userInfo, setUserInfo] = useState(user || {});

  useEffect(() => {
    API.get('/auth/me').then(r => {
      const d = r.data;
      if (d) {
        const perms = typeof d.menu_permissions === 'string' ? JSON.parse(d.menu_permissions) : d.menu_permissions;
        setMenuPerms(perms);
        setUserInfo(d);
        const stored = JSON.parse(localStorage.getItem('user') || '{}');
        Object.assign(stored, { menu_permissions: perms, position: d.position, avatar: d.avatar, department_name: d.department_name });
        localStorage.setItem('user', JSON.stringify(stored));
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const loadNotifs = () => {
      API.get('/dashboard/stats').then(r => {
        const d = r.data;
        const req = d.requests || {};
        const active = (+req.open_count || 0) + (+req.assigned || 0)
                     + (+req.in_progress || 0) + (+req.pending || 0);
        setNotifs({
          leave: 0,
          admission: d.pendingAdmissions || 0,
          enrollment: d.enrollment?.pending || 0,
          requests: active,
        });
      }).catch(() => {});
      API.get('/notifications', { params: { limit: 20 } }).then(r => {
        setNotifItems(r.data.items || []);
        setNotifUnread(r.data.unread || 0);
      }).catch(() => {});
      // Tam siyahı saxlanılır: nişan say üçün hamısına baxmalıdır,
      // açılan siyahı isə ilk 10-u göstərir.
      API.get('/requests', { params: { mine: '1' } }).then(r => {
        setMyTickets(r.data || []);
      }).catch(() => {});
      // Təchizat sorğuları ayrı modullardır — "Mənim sorğularım"
      // səhifəsi onları da sayır, nişan da saymalıdır.
      API.get('/procurement').then(r => {
        const me = user?.id;
        setMyProc((r.data || []).filter(p => p.requester_id === me));
      }).catch(() => {});
      API.get('/conversations').then(r => {
        const total = r.data.reduce((s, c) => s + (c.unread_count || 0), 0);
        setChatUnread(total);
      }).catch(() => {});
    };
    loadNotifs();
    const iv = setInterval(loadNotifs, 30000);

    // Real-time: listen for ticket:notify on a shared socket
    const token = localStorage.getItem('token');
    if (token) {
      const sock = getNotifSocket(token);
      const onNotify = () => { loadNotifs(); playNotifBeep(); };
      sock.on('notification:new', onNotify);
      sock.on('ticket:notify', onNotify);
      sock.on('ticket:new', onNotify);
      sock.on('ticket:updated', loadNotifs);
      return () => {
        clearInterval(iv);
        sock.off('notification:new', onNotify);
        sock.off('ticket:notify', onNotify);
        sock.off('ticket:new', onNotify);
        sock.off('ticket:updated', loadNotifs);
      };
    }
    return () => clearInterval(iv);
  }, []);

  // Qəbul/qeydiyyat sətirləri bildiriş deyil — canlı sayğaclardır, ona görə
  // "oxundu" işarələnə bilmir. Baxıldıqdan sonra susdurulur; say artarsa
  // yenidən görünür, yəni yeni iş gözdən qaçmır.
  // "Aktiv" tərifi "Mənim sorğularım" səhifəsi ilə eyni olmalıdır,
  // yoxsa nişandakı rəqəm səhifədəki ilə uyğun gəlmir.
  const DONE_STATUSES = ['resolved', 'closed', 'completed', 'cancelled'];
  const isActiveReq = (x) => !DONE_STATUSES.includes(x.status);
  const myActiveCount = myTickets.filter(isActiveReq).length + myProc.filter(isActiveReq).length;

  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem('ems_counter_seen') || '{}'); }
    catch { return {}; }
  });
  const dismissCounter = (key, count) => {
    setDismissed(prev => {
      const next = { ...prev, [key]: count };
      try { localStorage.setItem('ems_counter_seen', JSON.stringify(next)); } catch {}
      return next;
    });
  };
  const showAdmission  = (notifs.admission  || 0) > (dismissed.admission  || 0);
  const showEnrollment = (notifs.enrollment || 0) > (dismissed.enrollment || 0);

  // Zəngdəki rəqəm açılan siyahıdakı sətir sayı ilə üst-üstə düşməlidir:
  // qəbul/qeydiyyat bir-bir sətir kimi görünür, ona görə hərəsi 1 sayılır.
  const totalNotifs = notifUnread
    + (showAdmission  ? 1 : 0)
    + (showEnrollment ? 1 : 0);

  const markRead = async (id, link) => {
    try { await API.put('/notifications/' + id + '/read'); } catch (e) {}
    setNotifItems(prev => prev.map(n => n.id === id ? { ...n, is_read: 1 } : n));
    setNotifUnread(u => Math.max(0, u - 1));
    setShowNotif(false);
    if (link) navigate(link);
  };
  const markAllRead = async () => {
    try { await API.put('/notifications/read-all'); } catch (e) {}
    setNotifItems(prev => prev.map(n => ({ ...n, is_read: 1 })));
    setNotifUnread(0);
  };
  const handleLogout = () => { logout(); navigate('/login'); };

  /* İstifadəçinin kampusu. Admində filial seçicisi onsuz da var, ona görə
     yalnız adi istifadəçiyə və yalnız Baş Kampusdan fərqli olduqda yazılır. */
  /* Admin kampus süzgəci qoyubsa, onun adı — xəbərdarlıq zolağı üçün */
  const [aktivFilial, setAktivFilial] = useState('');
  useEffect(() => {
    if (user?.role !== 'admin') { setAktivFilial(''); return; }
    const b = getBranch();
    if (!b || b === 'all') { setAktivFilial(''); return; }
    let alive = true;
    API.get('/branches')
      .then(r => {
        const f = (r.data || []).find(x => String(x.id) === String(b));
        if (alive) setAktivFilial(f ? (f.short_name || f.name) : 'seçilmiş');
      })
      .catch(() => { if (alive) setAktivFilial('seçilmiş'); });
    return () => { alive = false; };
  }, [user]);

  const [campusName, setCampusName] = useState('');
  useEffect(() => {
    if (!user || user.role === 'admin' || !user.branch_id) { setCampusName(''); return; }
    let alive = true;
    API.get('/branches')
      .then(r => {
        const b = (r.data || []).find(x => String(x.id) === String(user.branch_id));
        if (alive && b && b.code !== 'MAIN') setCampusName(b.short_name || b.name);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [user]);

  return (
    <div data-yan-tema={yanTema} data-yan-naxis={yanNaxis} data-menyu={menyuGorunus}
         className={`layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'} ${mobileOpen ? 'mobile-sidebar-open' : ''} ${topbarHidden ? 'topbar-hidden' : ''}`}>
      <div className={`sidebar-overlay ${mobileOpen ? 'show' : ''}`} onClick={() => setMobileOpen(false)} />
      <aside className={`sidebar ${mobileOpen ? 'open' : ''}`}>
        <button className="sidebar-close-btn" onClick={() => setMobileOpen(false)} aria-label="Close menu">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
        <div className="sidebar-header">
          <img src="/mtk-logo.svg" alt="Logo" className="sidebar-logo" />
          <div className="sidebar-title">
            <span className="school-name">Heydər Əliyev adına</span>
            <span className="school-name2">Müasir Təhsil Kompleksi</span>
            {/* Kampuslar tam ayrıdır — işçi hansı kampusda olduğunu
                başlıqda görür. Baş Kampusda əlavə yazı çıxmır. */}
            {campusName && <span className="school-campus">{campusName}</span>}
          </div>
        </div>
        <nav className="sidebar-nav">
          {(() => {
            const visible = menuItems.filter(m => {
              if (m.herkese) return true;
              if (user?.role === 'admin') return true;
              // Anbar menyu icazəsindən deyil, şöbə üzvlüyündən asılıdır
              if (m.deptGated === 'warehouse') return whAccess;
              const perms = menuPerms || user?.menu_permissions;
              if (!perms || !Array.isArray(perms) || perms.length === 0) return false;
              const key = m.path === '/' ? 'dashboard' : m.path.replace('/', '');
              return perms.includes(key);
            });
            return GROUP_ORDER.map(group => {
              const items = visible.filter(m => m.group === group);
              if (!items.length) return null;
              return (
                <div key={group} className={'nav-group group-' + group}>
                  <div className="nav-group-label">{t(GROUP_KEYS[group])}</div>
                  {items.map(item => (
                    <NavLink
                      key={item.path}
                      to={item.path}
                      end={item.exact}
                      onClick={() => setMobileOpen(false)}
                      className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                    >
                      <span className="nav-icon">{Icons[item.icon]}</span>
                      <span className="nav-label">{t('sidebar.' + (SIDEBAR_KEYS[item.path] || ''), item.label)}</span>
                      {item.path === '/requests' && notifs.requests > 0 && (
                        <span className="nav-badge">{notifs.requests}</span>
                      )}
                      {item.path === '/enrollment' && (notifs.admission + notifs.enrollment) > 0 && (
                        <span className="nav-badge">{notifs.admission + notifs.enrollment}</span>
                      )}
                    </NavLink>
                  ))}
                </div>
              );
            });
          })()}
        </nav>
        <div className="sidebar-footer">
          <div className="user-info">
            <label className="user-avatar-wrap" title={t('topbar.changePhoto')}>
              {userInfo.avatar ? (
                <img src={userInfo.avatar} alt="" className="user-avatar-img" />
              ) : (
                <div className="user-avatar">{user?.name?.charAt(0)}</div>
              )}
              <div className="avatar-edit-icon">
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
              </div>
              <input type="file" accept="image/*" style={{display:'none'}} onChange={async e => {
                const file = e.target.files[0];
                if (!file) return;
                const fd = new FormData();
                fd.append('avatar', file);
                try {
                  const res = await API.post('/users/' + user.id + '/avatar', fd, {headers:{'Content-Type':'multipart/form-data'}});
                  setUserInfo(prev => ({...prev, avatar: res.data.avatar}));
                  const stored = JSON.parse(localStorage.getItem('user') || '{}');
                  stored.avatar = res.data.avatar;
                  localStorage.setItem('user', JSON.stringify(stored));
                } catch(err) {}
              }} />
            </label>
            <div className="user-details">
              <span className="user-name">{user?.name}</span>
              <span className="user-role">{userInfo.position || user?.role}</span>
              {userInfo.department_name && <span className="user-dept">{userInfo.department_name}</span>}
            </div>
          </div>

          {/* Menyunun rəngi, naxışı və quruluşu artıq burada deyil —
              SİSTEM bölməsindəki "Menyu quraşdırması" səhifəsindədir.
              Altbilgidə yalnız çıxış düyməsi qalır. */}
          <div className="sb-alt-setir sb-alt-setir-tek">
            <button className="logout-btn" onClick={handleLogout} title={t('topbar.logout')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/>
              </svg>
            </button>
          </div>

        </div>
        {/* Versiya istifadəçi kartının İÇİNDƏ deyil, altındadır — kartın
            flex sətrində ad və vəzifəni sıxışdırırdı. */}
        <button type="button" className="sidebar-version"
          onClick={() => { setMobileOpen(false); navigate('/about'); }}
          title="Sistem haqqında">
          v{APP_VERSION}
        </button>
      </aside>
      <div className="main-content">
        <header className="topbar">
          <button className="menu-toggle" onClick={() => {
            if (typeof window !== 'undefined' && window.matchMedia('(max-width: 760px)').matches) {
              setMobileOpen(o => !o);
            } else {
              setSidebarOpen(o => !o);
            }
          }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" width="20" height="20">
              <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
            </svg>
          </button>
          {/* Üst panel sistemin adını təkrarlayırdı — o, yan panelin
              başlığında onsuz da yazılıb. İndi burada hansı səhifədə
              olduğun yazılır; sistem adı kiçik alt sətirdə qalır. */}
          <h1 className="topbar-title">
            <span className={'topbar-page' + (basliqAxsin ? ' axan' : '')} ref={basliqRef}>
              <span className="topbar-page-mtn" ref={basliqMtnRef}>{sehifeAdi}</span>
            </span>
            <span className="topbar-sub">{t('topbar.title')}</span>
          </h1>
          {/* Sağdakı düymələr ayrı-ayrı üzən ikonlar idi; indi bir
              qrupdurlar — panel yığcam görünür */}
          <div className="topbar-tools">
            {/* Üst paneli yığmaq — ekranda cədvəl üçün yer açır */}
            <button className="topbar-collapse" onClick={toggleTopbar} title={t('topbar.hidePanel')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"
                strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
                <polyline points="18 15 12 9 6 15"/>
              </svg>
            </button>
            {/* Language toggle */}
            <BranchSwitcher role={user?.role} />
            <div className="lang-toggle-wrap">
              <button className="lang-toggle-btn" onClick={() => setLangOpen(o => !o)} title="Language">
                <span className="lang-toggle-current">{lang === 'az' ? 'AZ' : 'EN'}</span>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" style={{ transition: 'transform .15s', transform: langOpen ? 'rotate(180deg)' : 'rotate(0)' }}>
                  <polyline points="6 9 12 15 18 9"/>
                </svg>
              </button>
              {langOpen && (
                <>
                  <div className="lang-dropdown-overlay" onClick={() => setLangOpen(false)} />
                  <div className="lang-dropdown">
                    <button className={`lang-dropdown-item ${lang === 'az' ? 'active' : ''}`} onClick={() => { switchLang('az'); setLangOpen(false); }}>
                      AZ <span className="lang-dropdown-name">Azərbaycan</span>
                    </button>
                    <button className={`lang-dropdown-item ${lang === 'en' ? 'active' : ''}`} onClick={() => { switchLang('en'); setLangOpen(false); }}>
                      EN <span className="lang-dropdown-name">English</span>
                    </button>
                  </div>
                </>
              )}
            </div>
            {/* Chat icon */}
            <button className={'notif-bell' + (location.pathname === '/chat' ? ' active' : '')} onClick={toggleChat} title={t('topbar.messages')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="20" height="20">
                <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
              </svg>
              {chatUnread > 0 && <span className="notif-count">{chatUnread}</span>}
            </button>
            {/* My tickets icon — opens /my-requests page */}
            <button className="notif-bell" onClick={() => navigate('/my-requests')} title={t('topbar.myRequests')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="20" height="20">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                <polyline points="14,2 14,8 20,8"/><line x1="12" y1="18" x2="12" y2="12"/><line x1="9" y1="15" x2="15" y2="15"/>
              </svg>
              {myActiveCount > 0 && <span className="notif-count">{myActiveCount}</span>}
            </button>
            {/* Notifications */}
            <div style={{position:'relative'}}>
              <button className="notif-bell" onClick={() => setShowNotif(!showNotif)}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="20" height="20">
                  <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/>
                </svg>
                {totalNotifs > 0 && <span className="notif-count">{totalNotifs}</span>}
              </button>
              {showNotif && (
                <div className="notif-dropdown">
                  <div className="notif-header" style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                    <span>{t('topbar.notifications')}</span>
                    {notifUnread > 0 && (
                      <button onClick={markAllRead}
                        style={{background:'none',border:'none',color:'#1e40af',fontSize:12,cursor:'pointer',fontWeight:600}}>
                        {t('topbar.readAll')}
                      </button>
                    )}
                  </div>
                  {notifItems.length === 0 && totalNotifs === 0 && <div className="notif-empty">{t('topbar.noNotifications')}</div>}
                  {/* Gözləyən qəbul/qeydiyyat — daimi xəbərdarlıqdır, ona görə yuxarıda */}

                  {showAdmission && (
                    <div className="notif-item" style={{cursor:'pointer'}}
                      onClick={() => { dismissCounter('admission', notifs.admission); setShowNotif(false); navigate('/enrollment?tab=admissions'); }}>
                      <span className="notif-icon" style={{background:'#fef3c7',color:'#b45309'}}><Icon name="graduation" size={16} /></span>
                      <div style={{flex:1,minWidth:0}}>
                        <div className="notif-text"><b>{notifs.admission}</b> {t('topbar.admissionWaiting')}</div>
                        <div className="notif-sub">{t('topbar.enrollmentSubmenu')}</div>
                      </div>
                      <button className="notif-dismiss" title="Gizlət"
                        onClick={(e) => { e.stopPropagation(); dismissCounter('admission', notifs.admission); }}>
                        <Icon name="close" size={13} />
                      </button>
                    </div>
                  )}
                  {showEnrollment && (
                    <div className="notif-item" style={{cursor:'pointer'}}
                      onClick={() => { dismissCounter('enrollment', notifs.enrollment); setShowNotif(false); navigate('/enrollment'); }}>
                      <span className="notif-icon" style={{background:'#dbeafe',color:'#1e40af'}}><Icon name="edit" size={16} /></span>
                      <div style={{flex:1,minWidth:0}}>
                        <div className="notif-text"><b>{notifs.enrollment}</b> {t('topbar.studentSignWaiting')}</div>
                        <div className="notif-sub">{t('topbar.enrollmentTable')}</div>
                      </div>
                      <button className="notif-dismiss" title="Gizlət"
                        onClick={(e) => { e.stopPropagation(); dismissCounter('enrollment', notifs.enrollment); }}>
                        <Icon name="close" size={13} />
                      </button>
                    </div>
                  )}

                  {notifItems.map(n => {
                    const iconName = n.type === 'ticket_new' ? 'clipboard'
                      : n.type === 'ticket_assigned' ? 'pin'
                      : n.type === 'ticket_started' ? 'play'
                      : n.type === 'ticket_resolved' ? 'checkCircle'
                      : n.type === 'ticket_closed' ? 'lock'
                      : n.type === 'ticket_comment' ? 'message'
                      : n.type === 'ticket_comment_internal' ? 'message'
                      // Təchizat zəncirinin mərhələləri
                      : n.type === 'procurement_new' ? 'package'
                      : n.type === 'procurement_finance_pending' ? 'clock'
                      : n.type === 'procurement_director_pending' ? 'edit'
                      : n.type === 'procurement_progress' ? 'clock'
                      : n.type === 'procurement_approved' ? 'checkCircle'
                      : n.type === 'procurement_delivered' ? 'package'
                      : n.type === 'procurement_completed' ? 'checkCircle'
                      : n.type === 'procurement_rejected' ? 'closeCircle'
                      : 'bell';
                    return (
                      <div
                        key={n.id}
                        className="notif-item"
                        onClick={() => markRead(n.id, n.link)}
                        style={{
                          cursor:'pointer',
                          background: n.is_read ? 'transparent' : '#eff6ff',
                          borderLeft: n.is_read ? '3px solid transparent' : '3px solid #1e40af',
                        }}>
                        <span className="notif-icon" style={{background:'#dbeafe',color:'#1e40af'}}><Icon name={iconName} size={16} /></span>
                        <div style={{flex:1,minWidth:0}}>
                          <div className="notif-text" style={{fontWeight: n.is_read ? 400 : 600}}>{n.title}</div>
                          {n.body && <div className="notif-sub">{String(n.body).slice(0, 80)}</div>}
                          <div className="notif-sub" style={{fontSize:10,opacity:0.7}}>
                            {fmtShortTime(n.created_at, lang)}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </header>
        {/* Panel yığılanda onu geri açmaq üçün kiçik dil */}
        {topbarHidden && (
          <button className="topbar-peek" onClick={toggleTopbar} title={t('topbar.showPanel')}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4"
              strokeLinecap="round" strokeLinejoin="round" width="16" height="16">
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </button>
        )}
        <main className="page-content">
          <div className="page-container">
            {/* Kampus süzgəci aktivdirsə açıq-aydın göstərilir. Əks halda admin
                boş siyahı görüb sistemin sıradan çıxdığını düşünür. */}
            {user?.role === 'admin' && aktivFilial && (
              <div className="branch-filter-banner">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"/>
                </svg>
                <span>
                  Yalnız <b>{aktivFilial}</b> kampusu göstərilir — digər kampusların
                  məlumatları gizlidir.
                </span>
                <button type="button" onClick={() => { setBranch('all'); window.location.reload(); }}>
                  Bütün kampusları göstər
                </button>
              </div>
            )}
            <Outlet />
          </div>
        </main>
      </div>
      <div style={{display:'none'}}><ChatWidget /></div>
    </div>
  );
}
